import { eTypeSnackBar } from "@/types/ui";
import { reactive } from "vue";
export const snackBar = reactive({
  message: "",
  visible: false,
  type: eTypeSnackBar.success,
});

export const setSnackBar = (message: string, type: eTypeSnackBar): void => {
  snackBar.message = message;
  snackBar.visible = true;
  snackBar.type = type ?? eTypeSnackBar.success;
};

export const clearNotificationSnackBar = (): void => {
  snackBar.message = "";
  snackBar.visible = false;
};
